import { render, staticRenderFns } from "./caisseView.vue?vue&type=template&id=512db6a2&"
import script from "./caisseView.vue?vue&type=script&lang=js&"
export * from "./caisseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports